import React, { useEffect, useRef, useState } from 'react';

import _ from 'lodash';
import ReactDOM from 'react-dom';

import Button from 'components/Button';
import { ENUM_TYPE_ACTION } from 'constants/enum';
import { TEXT_APP_SCREEN_PREVIEW, TEXT_COMMON, TEXT_CREATE_SURVEY } from 'constants/string/texts';

const SetUpSection = (props) => {
  const { form, close } = props;

  const modalSetUpSectionRef = useRef(null);
  const [sectionDraft, setSectionDraft] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dropIndex, setDropIndex] = useState(null);

  const getItemsNotDelete = (list_item) => {
    return list_item?.filter((item) => item.action !== ENUM_TYPE_ACTION.DELETE);
  };

  const closeModal = () => {
    close();
  };

  const onConfirm = () => {
    form.setFieldValue('sections', sectionDraft);
    closeModal();
  };

  const onClickMove = (currentIndex, targetIndex) => {
    setSectionDraft((prevState) => {
      let sections = _.cloneDeep(prevState);
      let [item] = _.pullAt(sections, currentIndex);
      sections = _.concat(_.slice(sections, 0, targetIndex), item, _.slice(sections, targetIndex));

      sections.map((section, index) => {
        section.order = index;
      });
      return sections;
    });
  };

  const clickBackdrop = () => {
    modalSetUpSectionRef.current.classList.add('animate-fade-out');
    setTimeout(() => {
      modalSetUpSectionRef.current.classList.remove('animate-fade-out');
    }, 300);
  };

  /**
   * Event Drag/Drop Section
   */
  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDrop = (e, sectionIndex) => {
    e.preventDefault();
    resetDragAndDrop();
    if (dropIndex !== null) {
      setSectionDraft((prevState) => {
        let sections = _.cloneDeep(prevState);
        let [item] = _.pullAt(sections, draggedIndex);
        sections = _.concat(_.slice(sections, 0, sectionIndex), item, _.slice(sections, sectionIndex));

        sections.map((section, index) => {
          section.order = index;
        });
        return sections;
      });
    }
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setDropIndex(index);
  };

  const resetDragAndDrop = () => {
    setDraggedIndex(null);
    setDropIndex(null);
  };

  useEffect(() => {
    if (form.values) {
      setSectionDraft(form.values?.sections || []);
    }
  }, [form.values]);

  return ReactDOM.createPortal(
    <div id="modal" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-50">
      <div onClick={clickBackdrop} className="fixed inset-0 backdrop" />

      <div ref={modalSetUpSectionRef} className="bg-white rounded-sm shadow-lg relative w-120 modal-content">
        <div className="flex-between-center px-6 py-4 ">
          <p className="font-bold">{TEXT_CREATE_SURVEY.SECTION_UPDATE_TITLE}</p>
        </div>

        <div className="p-3 border-t border-white-720">
          <div className="max-h-138 w-full overflow-y-auto p-3 grid grid-cols-1 gap-y-2">
            {getItemsNotDelete(sectionDraft)?.map((section, sectionIndex) => (
              <div
                draggable
                onDragStart={(e) => {
                  handleDragStart(e, sectionIndex);
                }}
                onDragOver={(e) => handleDragOver(e, sectionIndex)}
                onDrop={(e) => {
                  handleDrop(e, sectionIndex);
                }}
                key={`section-${sectionIndex}`}
                className="pt-0 pb-2 border-b border-solid border-black/6 flex-between-center h-16"
              >
                <div className="flex items-center">
                  <div className="py-5 px-4 cursor-move">
                    <img
                      className="rotate-90"
                      src={require('assets/resources/DragIndicatorsActive.svg').default}
                      alt="drag indicator"
                      width={16}
                      height={16}
                    />
                  </div>
                  <div className="py-0.75 px-4 w-72">
                    <p className="text-black-102 font-bold line-clamp-1 break-all">
                      {section?.title || `${TEXT_APP_SCREEN_PREVIEW.QUESTION_SECTION}${sectionIndex + 1}`}
                    </p>
                    <p className="text-black-102 text-sm line-clamp-1 break-all">
                      {`${TEXT_CREATE_SURVEY.SECTION}${sectionIndex + 1}/${getItemsNotDelete(sectionDraft).length}`}
                    </p>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="py-5 px-4">
                    <img
                      onClick={() => {
                        sectionIndex !== 0 && onClickMove(sectionIndex, sectionIndex - 1);
                      }}
                      className={`rotate-180 cursor-pointer ${sectionIndex === 0 && 'opacity-50'}`}
                      src={require('assets/resources/Arrow.svg').default}
                      alt="arrow"
                      width={16}
                      height={16}
                    />
                  </div>
                  <div className="py-5 px-4">
                    <img
                      onClick={() => {
                        sectionIndex !== getItemsNotDelete(sectionDraft).length - 1 && onClickMove(sectionIndex, sectionIndex + 1);
                      }}
                      className={`cursor-pointer ${sectionIndex === getItemsNotDelete(sectionDraft).length - 1 && 'opacity-50'}`}
                      src={require('assets/resources/Arrow.svg').default}
                      alt="arrow"
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="h-16 border-t border-white-720 flex-end-center gap-2 py-4 px-6">
          <Button className="h-8 text-sm w-25.5" text={TEXT_COMMON.CANCEL_TEXT} color="outline" onClick={closeModal} />
          <Button className="h-8 text-sm w-20" text={TEXT_COMMON.RENEW} color="primary" onClick={onConfirm} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default React.memo(SetUpSection);
